<template>
  <canvas width="50" height="50" class="gradient" />
</template>

<script>
  import granim from 'granim';
  export default {
    name: "BackgroundGradient",
    mounted() {
      new granim({
        element: '.gradient',
        direction: 'diagonal',
        states : {
          "default-state": {
            gradients: [
              ['#FF0000', '#990099'],
              ['#FF0000', '#990099'],
              ['#FF0000', '#990099']
            ]
          }
        }
      })
    }
  }
</script>

<style scoped>
  .gradient {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background-color: red;
  }
</style>